module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/5a6185e98c50f4e3fa5bf8210f8da836.png";